import { getToken } from "./apiHelper";
import api from "./api";

export const companyService = {
  getCurrentUsers: async () => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.get(
        `/v1/Users/GetMyCurrentsUsers`,
        axiosConfig
      );

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  getCompanyUsers: async () => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.get(
        `/v1/Users/GetListWithCurrents`,
        axiosConfig
      );
      console.log(response)
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  getUser: async (id) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.get(
        `/v1/Users/${id}`,
        axiosConfig
      );
      console.log(response)
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },

  createUser: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.post(
        `/v1/Users/CreateUserForMyCurrent`,
        data,
        axiosConfig
      );

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },

  createUserClaim: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.post(`/v1/user-groups`, data, axiosConfig);

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  updateUserClaim: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.put(`/v1/user-groups`, data, axiosConfig);

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  createCompanyUser: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.post(`/v1/Users`, data, axiosConfig);
 
      await api.post(
        `/v1/user-groups`,
        { userId: response.data.data.userId, groupId: data.groupId },
        axiosConfig
      );
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },

  updateUserPassword: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.put(
        `/v1/Auth/user-password`,
        data,
        axiosConfig
      );

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  updateUser: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.put(`/v1/Users`, data, axiosConfig);

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.delete(`/v1/Users/` + id, axiosConfig);
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
};
